<template>
  <div>
    <base-header class="pb-8 pt-3">
      <!-- Card stats -->
    </base-header>

    <!--Charts-->
    <b-container fluid class="mt--6">
      <b-row>
        <b-col>
          <b-card class="shadow" no-body>
            <b-card-body>
              <b-row class="d-flex">
                <b-form-group
                  label="Sucursal"
                  class="px-1 mb-0"
                  label-size="sm"
                >
                  <b-form-select v-model="filter.serie" size="sm">
                    <b-form-select-option value=""
                      >Todas mis sucursales</b-form-select-option
                    >
                    <b-form-select-option
                      v-for="(sucursal, ks) in sucursales"
                      :key="ks"
                      :value="sucursal.serie"
                    >
                      {{ sucursal.nombre }}
                      [ {{ sucursal.serie }} ]</b-form-select-option
                    >
                  </b-form-select>
                </b-form-group>
                <b-form-group
                  label="Del"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="date"
                    class="form-control-solid"
                    v-model="filter.init"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Al"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="date"
                    class="form-control-solid"
                    v-model="filter.end"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="UUID"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="text"
                    class="form-control-solid"
                    v-model="filter.uuid"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                  label="Total"
                  class="px-1 mb-0 flex-fill"
                  label-size="sm"
                >
                  <b-form-input
                    size="sm"
                    type="number"
                    class="form-control-solid"
                    v-model="filter.total"
                  ></b-form-input>
                </b-form-group>

                <div class="mt-auto flex-fill">
                  <b-button @click="getFind()" variant="primary" size="sm" block
                    >Buscar</b-button
                  >
                </div>
              </b-row>
              <b-table
                class="mt-2 table-responsive w-100 d-table"
                :fields="fileds"
                :items="rows"
                :busy="working"
                small
                hover
              >
                <template #cell(acciones)="row">
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="modalActions(row.item, row.index, $event.target)"
                    class="mr-1"
                  >
                    <i class="c-pointer fas fa-info"></i>
                  </b-button>
                </template>
                <template #table-busy>
                  <div class="text-center text-warning my-2">
                    <i class="fal fa-spinner fa-spin mr-2"></i>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
            </b-card-body>
            <div
              v-if="!rows.length & !working"
              class="text-center text-warning my-2"
            >
              <!-- <i class="fal fa-spinner fa-spin mr-2"></i> -->
              <strong>No se localizaron registros coincidentes</strong>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      ref="modal-cfdi-acciones"
      hide-footer
      title="Acciones"
      body-class="border-top"
      header-class="py-2 align-items-baseline"
      size="lg"
    >
      <template #modal-title>
        <h3>Acciones</h3>
      </template>
      <p class="mb-0 small">
        Serie: <strong>{{ cfdi.serie }}</strong>
      </p>
      <p class="mb-0 small">
        Emisor: <strong>{{ cfdi.emisor }}</strong>
      </p>
      <p class="mb-0 small">
        Receptor: <strong>{{ cfdi.receptor }}</strong>
      </p>
      <p class="mb-0 small">
        UUID: <strong>{{ cfdi.uuid }}</strong>
      </p>
      <p class="mb-0 small">
        Fecha Timbrado: <strong>{{ cfdi.fechaTimbrado }}</strong>
      </p>
      <p class="mb-0 small">
        Estatus:
        <span v-if="!cfdi.cancel" class="badge badge-success">Vigente</span>
        <span v-if="cfdi.cancel" class="badge badge-danger">Cancelado</span>
      </p>
      <div class="mt-2">
        <b-button
          :href="`${$backend}/api/facturacion/cfdi/${cfdi.uuid}/recuperar-pdf`"
          variant="info"
          size="sm"
          class="text-primary"
          target="_blank"
          download
        >
          <i class="fas fa-file-pdf mr-1"></i>PDF
        </b-button>
        <b-button
          :href="`${$backend}/api/facturacion/cfdi/${cfdi.uuid}/recuperar-xml`"
          variant="info"
          size="sm"
          class="text-primary"
          target="_blank"
          download
        >
          <i class="fas fa-file-excel mr-1"></i>XML
        </b-button>
        <b-button
          :href="`${$backend}/api/facturacion/cfdi/${cfdi.uuid}/recuperar-pdf-ticket`"
          variant="info"
          size="sm"
          class="text-primary"
          target="_blank"
          download
        >
          <i class="fas fa-file-pdf mr-1"></i>PDF Ticket
        </b-button>
        <b-button
          :href="`${$backend}/api/facturacion/descargar/${cfdi.uuid}`"
          variant="info"
          size="sm"
          class="text-primary"
          target="_blank"
          download
        >
          <i class="fas fa-download mr-1"></i>Descargar ZIP
        </b-button>
        <b-button
          @click="sendEmail(cfdi.uuid)"
          class="btn btn-sm btn-info text-primary"
          ><i class="fas fa-paper-plane mr-1"></i>Enviar por Email</b-button
        >
        <hr class="my-2" />
      </div>
      <div v-if="!cfdi.cancel" class="d-flex justify-content-between">
        <!-- <b-btn variant="primary" size="sm" block disabled
        >Reenviar por Correo</b-btn
      > -->
        <!-- <b-btn variant="danger" size="sm" block disabled>Cancelar CFDI</b-btn> -->
        <button-delete
          v-if="
            !cancel.show &&
            (session.user.administrador || session.user.supervisor)
          "
          @onDelete="cancelInit(cfdi.uuid)"
          :cancel="cfdi.cancel"
          label="Iniciar cancelación"
        />
        <div v-if="cancel.show" class="w-100">
          <div class="d-flex justify-content-between">
            <h5>Cancelar comprobante</h5>
            <i
              @click="cancel.show = false"
              class="fas fa-times-circle text-gray"
            ></i>
          </div>
          <div class="form-group mb-1">
            <label for="" class="small">Motivo Cancelación</label>
            <select
              v-model="cancel.motivo"
              class="form-control form-control-sm form-control-solid"
            >
              <option
                v-for="motivo in cancel.options"
                :key="motivo.clave"
                :value="motivo.clave"
              >
                {{ motivo.description }}
              </option>
            </select>
          </div>
          <div
            v-if="cancel.motivo && cancel.motivo != '02'"
            class="alert alert-warning font-italic py-1 small"
          >
            Para generar el cfdi de remplazo, primero libere los tickets
            asociados, genere su nueva factura y asocie el UUID.
          </div>
          <h6>Tickets relacionados al CFDI</h6>
          <table v-if="cancel.ventas" class="table table-info table-sm">
            <thead class="bg-info">
              <tr>
                <th class="py-0">Serie</th>
                <th class="py-0">Folio</th>
                <th class="py-0">Total</th>
                <th class="py-0">Estatus</th>
                <th class="py-0"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="venta in cancel.ventas" :key="venta.id">
                <td>{{ venta.numserie }}</td>
                <td>{{ venta.numalbaran }}</td>
                <td>{{ venta.total }}</td>
                <td>
                  <span v-if="!venta.cancel" class="badge badge-success"
                    >Vigente</span
                  >
                  <span v-if="venta.cancel" class="badge badge-danger"
                    >Cancelado</span
                  >
                </td>
                <td>
                  <button-delete
                    @onDelete="cancelTicketCfdi(venta.id, cfdi.uuid)"
                    :cancel="venta.cancel"
                    label="Liberar Ticket"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <div v-if="cancel.motivo != '02'" class="form-group mb-1">
            <label for="" class="small">UUID Relacionado</label>
            <input
              v-model="cancel.folioSustitucion"
              type="text"
              class="form-control form-control-sm form-control-solid"
            />
          </div>
          <button-delete
            v-if="cancel.motivo"
            @onDelete="cancelCfdi(cfdi.uuid, cancel.motivo)"
            :cancel="cfdi.cancel"
            class="mt-1"
            label="Cancelar Comprobante"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";
import ButtonDelete from "@/components/IDBRICS/tools/ButtonDelete";

export default {
  components: {
    ButtonDelete,
  },
  data() {
    return {
      moment: moment,
      working: false,
      error: [],
      sucursales: [],
      filter: {
        serie: "",
        init: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
        total: "",
        uuid: "",
      },
      fileds: [
        {
          key: "serie",
          label: "SERIE",
          sortable: true,
        },
        {
          key: "fechaTimbrado",
          label: "FECHA TIMBRADO",
          sortable: true,
        },
        {
          key: "uuid",
          label: "uuid",
          sortable: true,
        },
        {
          key: "total",
          label: "TOTAL",
          class: "text-right",
          sortable: true,
        },
        {
          key: "emisor",
          label: "Emisor",
          sortable: true,
        },
        {
          key: "receptor",
          label: "Receptor",
          sortable: true,
        },
        {
          key: "acciones",
          label: "ACCIONES",
          class: "text-center",
          sortable: false,
        },
      ],
      rows: [],
      cfdi: {},
      cancel: {
        show: false,
        acuse: "",
        motivo: "",
        folioSustitucion: "",
        options: [
          {
            clave: "01",
            description: "Comprobante emitido con errores con relación.",
            help: "Cuando se cancela un CFDI para corregir errores en el mismo y se emite uno nuevo con los datos correctos.",
          },
          {
            clave: "02",
            description: "Comprobante emitido con errores sin relación.",
            help: "Cuando se cancela un CFDI con errores, pero no se emite un nuevo CFDI que lo sustituya.",
          },
          {
            clave: "03",
            description: "No se llevo a cabo la operación.",
            help: "",
          },
          {
            clave: "04",
            description:
              "Operación nominativa relacionada en una factura global",
            help: "Cuidado, al utilizar esta opción de comprobantes facturados globalmente.",
          },
        ],
        ventas: [],
      },
    };
  },
  beforeMount() {
    this.getSucursales();
    this.getFind();
  },
  computed: {
    ...mapState(["session"]),
  },
  methods: {
    getSucursales() {
      this.$api
        .get("/facturacion/sucursales")
        .then((response) => {
          this.sucursales = response.data;
        })
        .catch((e) => console.error(e));
    },
    getFind() {
      this.working = true;

      this.$api
        .get("/archivo/cfdi/sucursal", {
          params: this.filter,
        })
        .then((res) => {
          this.rows = res.data;
        })
        .catch((e) => console.log(e))
        .then((e) => {
          this.error = e;
          this.working = false;
        });
    },
    modalActions(item, index, target) {
      this.cfdi = item;
      this.$refs["modal-cfdi-acciones"].show();
    },
    sendEmail(uuid) {
      let mail = prompt(`Ingrese el destinatario`);

      let regex = new RegExp("[a-z0-9]+@[a-z]+\.[a-z]{2,3}");

      if (!regex.test(mail)) {
        this.$notiflix.Notify.failure(
          "El correo no cumple con el formato correcto."
        );
        return;
      }

      this.$api
        .post(`facturacion/cfdi/${uuid}/send-mail`, {
          recipients: [mail],
        })
        .then((response) => {
          this.$notiflix.Notify.success("Cfdi enviado.");
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors[0] || e.response.data
          );
        })
        .then(() => (this.working = false));
    },
    cancelInit(uuid) {
      this.working = false;

      this.$api
        .get(`facturacion/cfdi/${uuid}/ventas`)
        .then((response) => {
          // this.$notiflix.Notify.success("Cancelación exitosa.");
          this.cancel.ventas = response.data;
          this.cancel.show = true;
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors[0] || e.response.data
          );
        })
        .then(() => (this.working = false));
    },
    cancelTicketCfdi(venta_id, uuid) {
      this.working = true;

      this.$api
        .delete(`facturacion/cfdi/${uuid}/ventas/${venta_id}`)
        .then((response) => {
          this.$notiflix.Notify.success("Cancelación exitosa.");
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors[0] || e.response.data
          );
        })
        .then(() => (this.working = false));
    },
    cancelCfdi(uuid, motivo) {
      this.working = true;

      this.$api
        .delete(`facturacion/cfdi/${uuid}/cancelar`, {
          data: { motivo, folioSustitucion: this.cancel.folioSustitucion },
        })
        .then((response) => {
          this.cfdi.cancel = 1;
          this.cancel.acuse = response.data.acuse;
          this.$notiflix.Notify.success("Cancelación exitosa.");
        })
        .catch((e) => {
          this.$notiflix.Notify.failure(
            e.response.data.errors[0] || e.response.data
          );
        })
        .then(() => (this.working = false));
    },
  },
  filters: {
    formatNumberDecimal: function (value) {
      const options2 = {
        style: "decimal",
        currency: "USD",
        maximumFractionDigits: 2,
      };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);

      return numberFormat2.format(value);
    },
    formatNumberInteger: function (value) {
      const options2 = {
        style: "decimal",
        currency: "USD",
        maximumFractionDigits: 0,
      };
      const numberFormat2 = new Intl.NumberFormat("en-US", options2);

      return numberFormat2.format(value);
    },
  },
};
</script>
<style>
.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
</style>
